export default "__VITE_ASSET__59db0c77__"